import { useEffect, useState } from "react";
import { Autocomplete, type AutocompleteOption } from "@/components/ui/autocomplete";

interface FiscalComboboxProps {
  value?: string | null;
  onChange: (value: string) => void;
  options: AutocompleteOption[];
  placeholder: string;
}

export function FiscalCombobox({ value, onChange, options, placeholder }: FiscalComboboxProps) {
  const [displayText, setDisplayText] = useState(() => {
    const match = options.find((o) => o.value === value);
    return match ? match.label : "";
  });

  useEffect(() => {
    const match = options.find((o) => o.value === value);
    setDisplayText(match ? match.label : "");
  }, [value, options]);

  return (
    <Autocomplete
      options={options}
      value={displayText}
      selectedValue={value ?? ""}
      onChange={setDisplayText}
      onSelect={(option: AutocompleteOption) => {
        setDisplayText(option.label);
        onChange(option.value);
      }}
      placeholder={placeholder}
      openOnFocus
      openOnClick
    />
  );
}
